import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgRatingStar({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                clipRule="evenodd"
                d="m8.452.777 2.082 4.125 4.007.397a.5.5 0 0 1 .31.855l-3.297 3.268 1.223 4.441a.506.506 0 0 1-.716.582l-4.063-2.012-4.056 2.01a.506.506 0 0 1-.716-.582l1.222-4.442-3.3-3.268a.5.5 0 0 1 .311-.855L5.466 4.9 7.545.777a.51.51 0 0 1 .907 0Z"
                stroke="#297A71"
            />
        </svg>
    )
}
SvgRatingStar.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgRatingStar
